module.exports = __webpack_public_path__ + "img/layout-center-header.f1357b4f.png";